import { createSlice } from "@reduxjs/toolkit";
import {
  getDirectContact, getMessages, addMessage, deleteMessage, getChatContacts
} from './thunk';

export const initialState: any = {
  chats: [],
  messages: [],
  contacts: [],
  error: {},
  loading: true
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getDirectContact.pending, (state: any) => {
      state.loading = true;
    });
    builder.addCase(getDirectContact.fulfilled, (state: any, action: any) => {
      state.chats = action.payload;
      state.loading = false;
    });
    builder.addCase(getDirectContact.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
      state.loading = false;
    });

    builder.addCase(getMessages.pending, (state: any) => {
      state.loading = true;
    });
    builder.addCase(getMessages.fulfilled, (state: any, action: any) => {
      state.messages = action.payload;
      state.loading = false;
    });
    builder.addCase(getMessages.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
      state.loading = false;
    });

    builder.addCase(addMessage.fulfilled, (state: any, action: any) => {
      if (state.messages && state.messages.length > 0) {
        state.messages[0].usermessages.push(action.payload);
      } else {
        // If no messages yet, create the structure
        state.messages = [{
          id: 1,
          roomId: action.payload.roomId,
          sender: "Support",
          createdAt: new Date().toLocaleTimeString(),
          usermessages: [action.payload]
        }];
      }
    });
    builder.addCase(addMessage.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });

    builder.addCase(deleteMessage.fulfilled, (state: any, action: any) => {
      state.messages = (state.messages || []).map((data: any) => {
        const updateUserMsg = data.usermessages.filter((userMsg: any) => userMsg.id !== action.payload);
        return { ...data, usermessages: updateUserMsg }
      })
    });
    
    builder.addCase(deleteMessage.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });

    builder.addCase(getChatContacts.fulfilled, (state: any, action: any) => {
      state.contacts = action.payload;
    });
    builder.addCase(getChatContacts.rejected, (state: any, action: any) => {
      state.error = action.payload?.error || null;
    });

  },
});

export default chatSlice.reducer;